import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from 'src/components/store';
import { SmartPolicyModal } from '../dashboard/smart-policy-modal/smart-policy-modal';
import { QuickStartModal } from '../dashboard/quick-start-modal/quick-start-modal';
import { PolicyMode } from '@src/utils/enums';

interface OnboardingModalsProps {
    ignoreDraftToSmartPolicy?: boolean;
    shouldLoadVersions?: boolean;
}

export const OnboardingModals: React.FC<OnboardingModalsProps> = observer(({ ignoreDraftToSmartPolicy, shouldLoadVersions }) => {
    const [isSmartPolicyModalVisible, setIsSmartPolicyModalVisible] = useState(false);
    const [isQuickStartModalVisible, setIsQuickStartModalVisible] = useState(false);
    const { customerStore, fwVersionStore, uiStore } = useStores();

    useEffect(() => {
        if (shouldLoadVersions) {
            void fwVersionStore.loadVersionsList();
        }
    }, [shouldLoadVersions]);

    const isPolicyModeFirstTime = ignoreDraftToSmartPolicy ? fwVersionStore.isInitialVersion : customerStore.isPolicyModeFirstTime;

    useEffect(() => {
        if (isPolicyModeFirstTime) {
            const smartPolicyAlreadyShown = uiStore.smartPolicyModalShownByServiceId === customerStore.serviceId;
            const shouldShowSmartPolicyModal = customerStore.policyMode === PolicyMode.SMART_POLICY && !smartPolicyAlreadyShown;
            setIsSmartPolicyModalVisible(shouldShowSmartPolicyModal);
            if (shouldShowSmartPolicyModal) {
                uiStore.setSmartPolicyModalShownByServiceId(customerStore.serviceId);
            }
        }
    }, [customerStore.serviceId, fwVersionStore.isInitialVersion]);

    useEffect(() => {
        if (isPolicyModeFirstTime) {
            const draftExternalId = fwVersionStore.draftVersion?.externalId;
            const quickStartAlreadyShown = !!draftExternalId && uiStore.quickStartModalShownByDraftExternalId === draftExternalId;
            setIsQuickStartModalVisible(customerStore.policyMode === PolicyMode.QUICK_START && !quickStartAlreadyShown);
        }
    }, [customerStore.serviceId, fwVersionStore.isInitialVersion, customerStore.policyMode, customerStore.isPolicyModeFirstTime, fwVersionStore.draftVersion?.externalId]);

    useEffect(() => {
        if (isQuickStartModalVisible && customerStore.isQuickStartDraftReady) {
            uiStore.setQuickStartModalShownByDraftExternalId(fwVersionStore.draftVersion?.externalId);
        }
    }, [isQuickStartModalVisible, customerStore.isQuickStartDraftReady]);

    return (
        <>
            <SmartPolicyModal visible={isSmartPolicyModalVisible} setIsVisible={setIsSmartPolicyModalVisible}/>
            <QuickStartModal visible={isQuickStartModalVisible && customerStore.isQuickStartDraftReady} setIsVisible={setIsQuickStartModalVisible}/>
        </>
    );
});
